export default __webpack_public_path__ + "static/media/pragueGuideFront.43b7ca38.jpg";